attribute vec2 particleData; // x: life (0..1), y: id

varying float vAngle;
varying vec4 vColour;

uniform float time;
uniform float spinSpeed;
uniform float uProjectionScale; // viewportHeightPx / (2 * tan(fov/2))

// Size over life
uniform float sizeStart;      // e.g. 8.0
uniform float sizeEnd;        // e.g. 24.0

// Colour over life
uniform vec3 colourStart;     // start colour
uniform vec3 colourEnd;       // end colour

// Alpha curve via two thresholds
uniform float fadeIn;         // life where alpha rises (0..1)
uniform float fadeOutStart;   // life where alpha starts to fade (0..1)

void main() {
  float life = clamp(particleData.x, 0.0, 1.0);
  float id = particleData.y;

  float sizeSample = mix(sizeStart, sizeEnd, life);

  // Colour over life
  vec3 baseColour = mix(colourStart, colourEnd, life);

  // Alpha ramp-in and ramp-out
  float aIn = smoothstep(0.0, max(0.0001, fadeIn), life);
  float aOut = 1.0 - smoothstep(fadeOutStart, 1.0, life);
  float alpha = clamp(aIn * aOut, 0.0, 1.0);

  vec3 mvPosition = (modelViewMatrix * vec4(position, 1.0)).xyz;
  gl_Position = projectionMatrix * vec4(mvPosition, 1.0);
  gl_PointSize = sizeSample * uProjectionScale / max(0.0001, -mvPosition.z);

  vAngle = spinSpeed * time + id * 6.28318530718;
  vColour = vec4(baseColour, alpha);
}


